import { Skeleton } from '@/components/ui/skeleton.component';

export function LaboratoryProcedureLoading() {
  return (
    <div className="p-5 overflow-hidden">
      <Skeleton className="h-8 w-16" />

      <div>
        {[1, 2, 3, 4].map((index) => (
          <div key={index} className="flex items-center gap-2 border-b py-5">
            <Skeleton className="h-8 w-8" />
            <Skeleton className="h-8 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
